export const SHIPPER_NAMES_MAX_SIZE = 10000

/** 서버가 상한 초과를 HTTP 400 으로 거절하므로, 동적·URL 복원 size 는 보내기 전에 상한 이하로 내린다. */
export const normalizeQueryPageSize = (size: unknown, max: number): number => {
  const parsed = typeof size === 'number' ? size : Number(size)
  // floor 뒤로 판정한다 — 0.5 는 parsed > 0 을 통과하지만 Math.floor 가 0 으로 만들어 서버가 400 을 낸다.
  if (!Number.isFinite(parsed) || Math.floor(parsed) <= 0) return max
  return Math.min(Math.floor(parsed), max)
}
